import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CommonNotificationObject } from '../types';
import { INotificationAttrs } from '../../AppComponents/Notifications/types';

interface IAddOrdererNotificationsState extends Record<string, any> {
  notificationAttrs: INotificationAttrs;
  notification: CommonNotificationObject;
}

export const initialState: IAddOrdererNotificationsState = {
  notification: {},
  notificationAttrs: {} as INotificationAttrs,
};

const addOrdererNotificationsSlice = createSlice({
  name: 'addOrdererNotifications',
  initialState,
  reducers: {
    changeAddOrdererNotification(
      state,
      action: PayloadAction<CommonNotificationObject>,
    ) {
      state.notification = action.payload;

      if (Object.keys(state.notificationAttrs).length <= 0) {
        state.notificationAttrs = {
          mainLoad: 0,
          failed: false,
          fullyComplete: false,
        };
      }
    },
    changeAddOrdererNotificationAttrs(
      state,
      action: PayloadAction<Record<keyof INotificationAttrs, any>>,
    ) {
      state.notificationAttrs = {
        ...state.notificationAttrs,
        ...action.payload,
      };
    },
    clearAddOrdererNotifications() {
      return initialState;
    },
  },
});

export const {
  changeAddOrdererNotification,
  clearAddOrdererNotifications,
  changeAddOrdererNotificationAttrs,
} = addOrdererNotificationsSlice.actions;

export default addOrdererNotificationsSlice.reducer;
